export default {"src":"/_next/static/media/journey.a6195728.svg","height":512,"width":513};